import React, { useMemo, useState } from "react";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import i18n from "utils/i18n";
import ThemedLayout from "components/atoms/ThemedLayout";
import FilterTab from "./_tabs/filter";
import FavouritesTab from './_tabs/favourites'
import EroTab from "./_tabs/ero";
import ConfidantTab from './_tabs/confidant'
import HelperString from 'utils/helper-string'
import TabbedContent from 'components/molecules/TabbedContent'
import { settingsConstants } from 'utils/constants/settings-constants'
import HelperSetting from 'utils/helper-setting'
import { TESTID } from '_shared/config/testID'
import { dataConstants } from 'services/redux/data/constants'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import useRouteHomeHelper from 'utils/hooks/use-route-home-helper'

const HomeCoworkerIndexScene = () => {
	
	useRouteHomeHelper();
	
	const _settings = useSelector( state => {
		return state.data[dataConstants.SETTINGS];
	} );
	const [ topTabBar, setTopTabBar ] = useState( null )
	
	const tabBarItems = useMemo( () => {
		const items = [];
		
		if( HelperSetting.isYes( settingsConstants.COWORKER_ENABLE_SEARCH ) ) {
			items.push( {
				key: 'following',
				text: i18n.t( 'page.coworker.favourites' ),
				testID: TESTID.HOME.COWORKER.NAVIGATION.FAVOURITES,
				scene: ( props ) => {
					return <FavouritesTab />;
				}
			} )
		}
		
		if( HelperSetting.isYes( settingsConstants.ERO_ENABLE ) ) {
			items.push({
				key: 'ero',
				text: i18n.t( 'page.coworker.eros' ),
				testID: TESTID.HOME.COWORKER.NAVIGATION.EROS,
				scene: ( props ) => {
					return <EroTab />;
				}
			});
		}
		
		if( HelperSetting.isYes( settingsConstants.CONFIDANT_ENABLE ) ) {
			items.push( {
				key: 'confidant',
				text: i18n.t( 'page.coworker.confidants' ),
				testID: TESTID.HOME.COWORKER.NAVIGATION.CONFIDANT,
				scene: ( props ) => {
					return <ConfidantTab />;
				}
			} );
		}
		
		if( HelperSetting.isYes( settingsConstants.COWORKER_ENABLE_SEARCH ) ) {
			items.push( {
				key: 'search',
				text: i18n.t( 'page.coworker.search' ),
				testID: TESTID.HOME.COWORKER.NAVIGATION.SEARCH,
				scene: ( props ) => {
					return <FilterTab />;
				}
			} )
		}
		
		return items;
	}, [ _settings ]);
	
	const pageTitle = useMemo( () => {
		if( _.size( tabBarItems ) === 1 ) {
			return tabBarItems[0].text
		}
		
		return i18n.t( 'page.coworker.title' )
	}, [ tabBarItems ] )
	
	return (
		<ThemedSafeAreaComponentTop
			top={false}>

			<ThemedLayout
				contentWidth="narrow"
				title={ pageTitle }
				topNavigation={ true }
				topTabbar={ topTabBar }
				enableScrollView={ true }
				testID={ TESTID.HOME.COWORKER.SCREENS.INDEX }>
				
				<TabbedContent
					key={ HelperString.hash('profile-tabs' ) }
					topTabbar={ setTopTabBar }
					items={ tabBarItems }
				/>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

export default HomeCoworkerIndexScene
